export var routesConfig = [{
  router: 'root',
  children: ['home', {
    router: 'design',
    children: ['designHome']
  }, {
    router: 'productmanager',
    children: [{
      router: 'productmanager2',
      children: ['productmanagerList', 'productDetail']
    }, 'sourcearea', 'brand', 'category', 'comment', 'notice', 'labelingManagement', 'bargain']
  }, {
    router: 'customermanager',
    children: [{
      router: 'customermanager2',
      children: ['editcustomer', 'customerlist']
    }, 'captchaRecordList']
  }, {
    router: 'order',
    children: [{
      router: 'orderList',
      children: ['orderDetail']
    }, 'aftersaleslist']
  }, {
    router: 'freightmanager',
    children: ['freightsetting', 'sendtypesetting', 'areaManagement']
  }, {
    router: 'marketing',
    children: ['cardrecommend', {
      router: 'coupon',
      children: ['couponList', 'addcoupon', 'editcoupon', 'lookcoupon']
    }, {
      router: 'activity',
      children: [{
        router: 'activityList',
        children: ['addActivity', 'editActivity', 'lookActivity']
      }]
    }, 'trackingList']
  }, {
    router: 'articlemanagement',
    children: [{
      router: 'articlelist',
      children: ['editArticle', 'addArticle']
    }]
  }, {
    router: 'affiliate',
    children: ['brokerage', 'poster', 'databoard', 'distribution', {
      router: 'settlementmanager',
      children: ['settlement', 'settlementOrder']
    }]
  }, {
    router: 'systemsetting',
    children: ['basicsetting', 'feesetting', 'holidayset', 'accountList', 'deploy']
  }]
}];